import React, { useContext, useEffect, useState } from 'react';
import { withFirebase, FirebaseContext } from '../../firebase';
import { AuthUserContext } from '../../session';
import { CChartLine } from '@coreui/react-chartjs';
import { registerables, Chart } from 'chart.js';
import axios from 'axios';

Chart.register(...registerables);

const GoogleFitWeightChart = () => {
  const firebase = useContext(FirebaseContext);
  const authUser = useContext(AuthUserContext);
  const [weightData, setWeightData] = useState([]);
  const [labels, setLabels] = useState([]);
  const [fitData, setFitData] = useState(null);

  const [error, setError] = useState(null);
  const fhirEndpoint = 'https://fhir.mieros.cloud/fhir/Observation';

  useEffect(() => {
    // Fetch the Google OAuth access token from local storage
    const userSession = JSON.parse(localStorage.getItem('userSession'));

    if (userSession && userSession.mieGoogleToken) {
      fetchGoogleFitData(userSession.mieGoogleToken);
    } else {
      setError('Google OAuth token not found. Please sign in again. User is not authenticated or Firebase is not initialized.');
    }
  }, [authUser, firebase]);

  const fetchGoogleFitData = async (accessToken0) => {
    try {
      const accessToken = localStorage.getItem('googleAccessToken');

      if (!accessToken) {
        setError('Google OAuth token not found. Please sign in again.');
        return;
      }

      const headers = {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      };

      const requestBody = {
        aggregateBy: [{
          dataTypeName: "com.google.weight",
          dataSourceId: "derived:com.google.weight:com.google.android.gms:merge_weight"
        }],
        bucketByTime: { durationMillis: 86400000 }, // 1 day in milliseconds
        startTimeMillis: Date.now() - (30 * 24 * 60 * 60 * 1000), // Last 30 days
        endTimeMillis: Date.now(),
      };

      const response = await fetch('https://www.googleapis.com/fitness/v1/users/me/dataset:aggregate', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error response: ", errorData);
        throw new Error(errorData.error.message);
      }

      const data = await response.json();

      // Process the data and update the state
      const formattedLabels = data.bucket.map(item => formatDate(item.startTimeMillis));
      const formattedWeight = data.bucket.map(item => item.dataset[0].point[0]?.value[0].fpVal || 0); // Adjust for weight data
      setLabels(formattedLabels);
      setWeightData(formattedWeight);
      setFitData(data);

    } catch (err) {
      setError('Error fetching Google Fit data');
      console.error(err);
    }
  };

  const formatDate = (dateMillis) => {
    const date = new Date(parseInt(dateMillis)); // Ensure it's converted to a number
    if (isNaN(date.getTime())) {
      return 'Invalid Date';  // Handle any invalid dates
    }
    return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
  };

  const chartData = {
    labels: labels.length > 0 ? labels : ["No Data"], // Ensure no empty labels
    datasets: [
      {
        label: 'Weight',
        data: weightData.length > 0 ? weightData : [0], // Ensure no empty data,
        fill: false,
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
      },
    ],
  };

  const options = {
    scales: {
      x: {
        type: 'category', // Change to 'category' since we're using string labels
      },
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div>
      <h2>Weight Last Month</h2>
      {error && <p>Error: {error}</p>}
      <CChartLine data={chartData} options={options} />
    </div>
  );
};

export default withFirebase(GoogleFitWeightChart);
